import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative text-sm px-1 py-1 transition-colors cursor-pointer whitespace-nowrap ${
      isActive
        ? "text-primary-500 font-medium"
        : "text-foreground-700 hover:text-primary-400"
    }`;

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-100/95 backdrop-blur border-b border-background-300"
          : "bg-background-100"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 cursor-pointer shrink-0">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-film-fill text-xl text-background-50"></i>
              </span>
              <span className="text-lg font-bold tracking-wide text-foreground-950 font-heading">
                黄色影院
              </span>
            </Link>

            <nav className="hidden md:flex items-center gap-7">
              {navLinks.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="flex items-center gap-3">
            <form
              onSubmit={submitSearch}
              className="hidden md:flex items-center gap-2 bg-background-200 border border-background-300 rounded-md px-3 py-1.5 w-56 lg:w-64"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-500"></i>
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集..."
                className="bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 outline-none w-full"
              />
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-background-200 text-foreground-900 cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-40 bg-background-50 animate-fade-in overflow-y-auto">
          <div className="px-4 py-6">
            <form
              onSubmit={submitSearch}
              className="flex items-center gap-2 bg-background-200 border border-background-300 rounded-md px-3 py-2.5 mb-6"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line text-base text-foreground-500"></i>
              </span>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集..."
                className="bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 outline-none w-full"
              />
            </form>
            <nav className="flex flex-col">
              {navLinks.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `flex items-center justify-between px-4 py-4 rounded-lg mb-2 text-base cursor-pointer ${
                      isActive
                        ? "bg-primary-500 text-background-50 font-medium"
                        : "bg-background-100 text-foreground-800"
                    }`
                  }
                >
                  <span>{item.label}</span>
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}